require('./image.css');
var tmpl = require('./image.ejs');


function  formatPictures(src) {
    return src;
}
var Image = function (options) {
    options.video_image = formatPictures(options.video_image);

    var imageHtml = tmpl({'item':options});
    return imageHtml;
};

module.exports = Image;




// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.videohead.pc/app/modules/image/index.js